export default {

    dashboardTenantSubtitle: 'This is your organization overview.',
    dashboardCurrentScope: 'Current scope',
    dashboardNoScope: 'No scope selected',
    dashboardExplore: 'Explore and manage your security operation from one place.',

    dashboardMetricScopes: 'Active scopes',
    dashboardMetricScopesHint: 'Projects under analysis',
    dashboardMetricAssets: 'Assets',
    dashboardMetricAssetsHint: 'Inventory items',
    dashboardMetricControls: 'Tracked controls',
    dashboardMetricControlsHint: 'Controls with a treatment plan',
    dashboardMetricScans: 'Completed scans',
    dashboardMetricScansHint: 'Ciberdiagnóstico analyses executed',

    dashboardQuickAccess: 'Quick access',
    dashboardLinkAssets: 'Assets',
    dashboardLinkTreatment: 'Treatment plan',
    dashboardLinkNewScan: 'New scan',

    dashboardSuperTitle: 'Superadmin panel',
    dashboardSuperSubtitle: 'Platform overview.',
    dashboardMetricTenants: 'Organizations',
    dashboardMetricActivePlans: 'Active plans',
    dashboardMetricPendingRequests: 'Pending requests',
    dashboardLinkCompanies: 'Organizations',
    dashboardLinkPlans: 'Plans',
    dashboardLinkAddons: 'Add-ons',
    dashboardLinkRequests: 'Requests',
    dashboardLinkQuota: 'Usage',

};
